import React from 'react';
import { configureStore } from '@reduxjs/toolkit'
import { coursesApi } from '../api/courses'
import { miscDataReducer } from './miscSlice'
import { filtersReducer } from './filtersSlice'

export const setupStore = (preloadedState) => {
  return configureStore({
    reducer: {
      [coursesApi.reducerPath]: coursesApi.reducer,
      misc: miscDataReducer,
      filters: filtersReducer
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(coursesApi.middleware),
    preloadedState, 
  })
}